<template>
  <b-card
    no-body
    class="p-1"
  >
    <b-tabs lazy>
      <template #tabs-start>
        <li class="nav-item d-flex align-items-center mr-2">
          <h4 class="mb-0">
            Shortage Items
          </h4>
        </li>
      </template>

      <b-tab
        title="Salesman"
        active
      >
        <shortage-items-filter @filtersUpdated="filtersChangeHandler" />
        <shortage-items-table :filters="filters" />
      </b-tab>

      <b-tab title="Retailers">
        <retailer-shortage-items-filter @filtersUpdated="retailerFiltersChangeHandler" />
        <retailer-shortage-items-table :filters="retailerFilters" />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import {
  BCard,
  BTabs,
  BTab,
} from 'bootstrap-vue'
import ShortageItemsFilter from '@/components/Orders/ShortageItems/ShortageItemsFilter.vue'
import ShortageItemsTable from '@/components/Orders/ShortageItems/ShortageItemsTable.vue'
import dateMixin from '@/mixins/dateMixin'
import formatMixin from '@/mixins/formatMixin'
import RetailerShortageItemsFilter from '@/components/Retailers/RetailerShortageItems/RetailerShortageItemsFilter.vue'
import RetailerShortageItemsTable from '@/components/Retailers/RetailerShortageItems/RetailerShortageItemsTable.vue'

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    ShortageItemsTable,
    ShortageItemsFilter,
    RetailerShortageItemsFilter,
    RetailerShortageItemsTable,
  },
  mixins: [dateMixin, formatMixin],
  data() {
    return {
      filters: {
        start_date: this.formatedDate(new Date(Date.now()), 'YYYY-MM-DD'),
        end_date: this.formatedDate(new Date(Date.now()), 'YYYY-MM-DD'),
      },
      retailerFilters: {
        start_date: this.formatedDate(new Date(Date.now()), 'YYYY-MM-DD'),
        end_date: this.formatedDate(new Date(Date.now()), 'YYYY-MM-DD'),
      },
    }
  },
  methods: {
    filtersChangeHandler(filterData) {
      this.filters = filterData
    },
    retailerFiltersChangeHandler(filterData) {
      this.retailerFilters = filterData
    },
  },
}
</script>
